import type { default as _jquery } from "jquery";
import { BaseFormLogger as logger } from "../base-form-logger.js";

let loadScriptPromise: Promise<true> | null = null;
// Adding window var to trigger error message
declare global {
	interface Window { formLoadError: boolean; }
}
window.formLoadError = window.formLoadError || false;

export function loadMarketoScript() {
	if (loadScriptPromise === null) {
		loadScriptPromise = new Promise((accept, reject) => {
			logger.debug("loadMarketoScript START");
			$.getScript("https://go.mastercontrol.com/js/forms2/js/forms2.min.js")
				.done(function (_script, _textStatus) {
					logger.debug("loadMarketoScript COMPLETE");
					accept(true);
				})
				.fail(function (_jqxhr, _settings, exception) {
					logger.debug("loadMarketoScript FAIL");
					window.formLoadError = true;
					logger.error(exception);
					reject(exception);
				});
		});
	}
	return loadScriptPromise;
}
